export var ApiErrors;
(function (ApiErrors) {
    ApiErrors["DELIVERY_LOCATION_ASSOCIATED_WITH_BENEFICIARY_CANNOT_BE_DELETED"] = "DELIVERY_LOCATION_ASSOCIATED_WITH_BENEFICIARY_CANNOT_BE_DELETED";
})(ApiErrors || (ApiErrors = {}));
export var RechargeReportErrorCode;
(function (RechargeReportErrorCode) {
    RechargeReportErrorCode["NO_RECHARGES_FOUND"] = "NO_RECHARGES_FOUND";
    RechargeReportErrorCode["NO_ORDERS_FOUND"] = "NO_ORDERS_FOUND";
    RechargeReportErrorCode["REPORT_ROW_LIMIT_EXCEEDED"] = "REPORT_ROW_LIMIT_EXCEEDED";
    RechargeReportErrorCode["CONTRACT_NOT_FOUND"] = "CONTRACT_NOT_FOUND";
    RechargeReportErrorCode["INVALID_INPUT"] = "INVALID_INPUT";
    RechargeReportErrorCode["INVALID_REQUEST_BODY"] = "INVALID_REQUEST_BODY";
})(RechargeReportErrorCode || (RechargeReportErrorCode = {}));
